import axios from 'axios'
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { API } from "../../../helpers/constants";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import { RATES } from "../locales/namespaces";

const useContributionRate = () => {
	const { t } = useTranslation(RATES)
	const [loading, setLoading] = useState(false)
	
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
		dataManager
	} = useMuiGridServerSide({
		url: `parameters/contributions/index`,
		initialPageSize: 50,
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	
	const store = (newRow) => {
		axios.post(`${API}/en/parameters/contributions/store`,
			{
				FromDt: newRow.FromDt ? dayjs(newRow.FromDt).format('YYYY-MM-DD') : '',
				Description: newRow.Description
			})
		.then(res => {
			enqueueSnackbar(t('Contribution Rate created successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			dataManager()
		}).catch(error => {
			const message = error.response?.data && error.response.data[0] ? error.response.data[0] : ''
			enqueueSnackbar(handleAxiosErrors(error, t(message)), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			dataManager()
		})
	}
	const update = (newRow, oldRow) => {
		axios.post(`${API}/en/parameters/contributions/update`, {
			id: newRow.id,
			Description: newRow.Description,
			FromDt: newRow.FromDt ? dayjs(newRow.FromDt).format('YYYY-MM-DD') : '',
		}).then(response => {
			enqueueSnackbar(t('Contribution Rate updated successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			dataManager()
		}).catch(error => {
			const message = error.response?.data && error.response.data[0] ? error.response.data[0] : ''
			enqueueSnackbar(handleAxiosErrors(error, t(message)), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			dataManager()
		})
	}
	
	const remove = (id) => {
		axios.post(`${API}/en/parameters/contributions/remove`, {id: id}).then(res => {
			enqueueSnackbar(t('Contribution Rate deleted successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			dataManager()
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			dataManager()
		})
	}
	
	return {
		data,
		isLoading,
		loading,
		store,
		remove,
		update,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
	}
}
export default useContributionRate